import { useAppStore } from '../../store/store';

export const useRightPanel = () => {
  const rightPanelContent = useAppStore((state) => state.rightPanelContent);
  const setRightPanelContent = useAppStore((state) => state.setRightPanelContent);
  const isRightPanelOpen = useAppStore((state) => state.isRightPanelOpen);
  const hasRightPanelCloseButton = useAppStore((state) => state.hasRightPanelCloseButton);
  const setHasRightPanelCloseButton = useAppStore((state) => state.setHasRightPanelCloseButton);
  const isRightPanelCheckDirtyOnClose = useAppStore((state) => state.isRightPanelCheckDirtyOnClose);
  const setIsRightPanelCheckDirtyOnClose = useAppStore(
    (state) => state.setIsRightPanelCheckDirtyOnClose,
  );
  const rightPanelKind = useAppStore((state) => state.rightPanelKind);
  const setRightPanelKind = useAppStore((state) => state.setRightPanelKind);
  const openRightPanel = useAppStore((state) => state.openRightPanel);
  const closeRightPanel = useAppStore((state) => state.closeRightPanel);
  const toggleRightPanel = useAppStore((state) => state.toggleRightPanel);

  return {
    rightPanelContent,
    setRightPanelContent,
    isRightPanelOpen,
    hasRightPanelCloseButton,
    setHasRightPanelCloseButton,
    isRightPanelCheckDirtyOnClose,
    setIsRightPanelCheckDirtyOnClose,
    rightPanelKind,
    setRightPanelKind,
    openRightPanel,
    closeRightPanel,
    toggleRightPanel,
  };
};
